exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo{top:15px;z-index:31;margin-left:100px}.colorback{background-color:#d9d9d9;border-radius:5px}.is-checkradio[type=checkbox]+label:before,.is-checkradio[type=radio]+label:before{position:absolute;left:0;top:0;content:\"\";border:.1rem solid #706f6f}.is-checkradio[type=checkbox]:checked+label:before,.is-checkradio[type=radio]:checked+label:before{border:.1rem solid #706f6f}.borderbox{box-shadow:0 0 0 3px #6600c5,0 0 0 1px #8000f7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b5366168","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/clima/EncuestaClima.vue
// module id = 966
// module chunks = 2